import React from 'react';
import { useTheme } from '@cobalt/react-theme-provider';

import Flex from '@cobalt/react-flex';
import Icon from '@cobalt/react-icon';
import { Text } from '@cobalt/react-typography';

interface FeedbackProps {
  message: string;
}

const Feedback = (props: FeedbackProps) => {
  const { message } = props;

  const theme = useTheme();

  return (
    <Flex gap={1}>
      <Icon name="error_outline" color={theme.error700} size="micro" />

      <Text color={theme.error700} size="small">
        {message}
      </Text>
    </Flex>
  );
};

export default Feedback;
